module.exports = __webpack_public_path__ + "static/media/P2-Tip.6e00fa71.svg";